import React from 'react';
import { Dialog, DialogContent, DialogActions, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { InvestorOtherCriteria } from '../../types/types';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import Form from '../../components/Form';
import { StyledText } from '../../components/StyledText';
import { formikSubmitDisabled } from '../../lib/utils';

export const validationSchema = Yup.object().shape({
  otherCriteria: Yup.string().nullable().trim()
});

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(0),
    minWidth: 400
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 24px'
  }
}));

export interface InvestorOtherCriteriaPanelEditProps {
  open: boolean
  otherCriteria: InvestorOtherCriteria
  handleSubmit: (values: InvestorOtherCriteria) => void
  handleClose: () => void
}

const InvestorOtherCriteriaPanelEdit: React.FC<InvestorOtherCriteriaPanelEditProps> = ({
  open, otherCriteria, handleSubmit, handleClose
}) => {
  const styles = useStyles();
  const formikSubmit = (values: any) => {
    handleSubmit(values.otherCriteria);
  };

  const formik = useFormik({
    initialValues: { otherCriteria },
    validationSchema,
    onSubmit: formikSubmit,
    enableReinitialize: true
  });

  const handleCancel = () => {
    handleClose();
    formik.resetForm();
  };

  const isBig = useMediaQuery('(min-width: 665px)');
  const minWidth = isBig ? '530px' : '330px';
  return (
    <Dialog
      open={open}
      className={styles.root}
      onClose={handleClose}
    >
      <Form formik={formik}>
        <DialogContent>
          <StyledText variant='h2'>Other Criteria</StyledText>
          <TextInput
            type='text'
            minRows={5}
            maxRows={10}
            multiline
            minWidth={minWidth}
            fullWidth
            id='otherCriteria'
            label='Other Investment Criteria'
            placeholder=''
          />
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          <Button type='button' variant='text' color='primary' onClick={handleCancel}>Cancel</Button>
          <Button type='submit' disabled={formikSubmitDisabled(formik)}>Save</Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default InvestorOtherCriteriaPanelEdit;

